import { Typography } from "@mui/material";
import { convertToDateTime } from "../../utils/datetime";

export default (date: string | null | undefined, showInline: boolean = false) => {
  if (!date || date === "0" || new Date(date).getTime() === 0) {
    return showInline ? "-" : <Typography>-</Typography>;
  }

  return showInline ? convertToDateTime(date) : <Typography>{convertToDateTime(date)}</Typography>;
};
